import React from 'react';

const DefaultTable = ({ dados, th1, th2, th3, th4, th5, th6, th7 }) => (
  <div
    style={{
      maxWidth: '100%',
      overflowY: 'scroll',
      overflowX: 'scroll'
    }}
  >
    <table
      style={{
        width: '100%',
        boxShadow: '0px 1px 4px rgb(58, 58, 58, 0.25)',
        borderRadius: '8px'
      }}
    >
      <thead style={{ background: '#cccc' }}>
        <tr width="5px">
          {th1 ? <th>{th1}</th> : <th>&nbsp;</th>}
          {th2 ? <th>{th2}</th> : <th>&nbsp;</th>}
          {th3 ? <th>{th3}</th> : <th>&nbsp;</th>}
          {th4 ? <th>{th4}</th> : <th>&nbsp;</th>}
          {th5 ? <th>{th5}</th> : <th>&nbsp;</th>}
          {/* {th6 ? <th>{th6}</th> : <th>&nbsp;</th>} */}
          {th7 ? <th>{th7}</th> : <th>&nbsp;</th>}
        </tr>
      </thead>
      <tbody>
        {dados &&
          dados.map((a, i) =>
            a.name != 'Menor Proficiência' &&
            a.name !== 'Desvio padrão' &&
            a.name !== 'Mediana' &&
            a.name !== 'Maior Proficiência' &&
            a.name !== 'Saeb Oficial' &&
            a.name !== 'ENEM Oficial' ? (
              <tr key={a.i}>
                <td
                  style={{
                    fontWeight: 600,
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  {a.name}
                </td>
                <td>
                  {a.minimo ? a.minimo.toFixed(2).replace('.', ',') : '0.00'}
                </td>
                <td>
                  {a.mediana ? a.mediana.toFixed(2).replace('.', ',') : '-'}
                </td>
                <td>
                  {a.data ? a.data[0][1].toFixed(2).replace('.', ',') : '-'}
                </td>
                <td>
                  {a.maximo ? a.maximo.toFixed(2).replace('.', ',') : '-'}
                </td>
                {/* <td>
                {a.desvio ? a.desvio.toFixed(2).replace('.', ',') : "-"}
              </td> */}
                <td>
                  {a.parametro ? a.parametro.toFixed(2).replace('.', ',') : '-'}
                </td>
              </tr>
            ) : (
              <></>
            )
          )}
      </tbody>
    </table>
  </div>
);

DefaultTable.defaultProps = {
  aplicacoes: []
};

export default DefaultTable;
